import React, { useEffect, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import UserManagement from "./UserManagement";
import {
  searchAllUsersAction,
  approvalUserAction,
  approvalUserInit,
  updateUseYnAction,
  updateUseYnInit,
  deleteUserAction,
  deleteUserInit
} from "../actionCreators";

const UserManagementContainer = () => {
  const dispatch = useDispatch();

  const {
    userList,
    isLoading,
    approvalResult,
    approvalError,
    isApprovalLoading,
    useYnResult,
    useYnError,
    isUseYnLoading,
    deleteResult,
    deleteError,
    isDeleteLoading
  } = useSelector(({ userManagementReducer }) => userManagementReducer);

  useEffect(() => {
    dispatch(searchAllUsersAction());
  }, [dispatch]);

  // 가입 승인/반려 후 목록 재조회
  useEffect(() => {
    if (approvalResult && approvalResult.retCode === "S00000") {
      dispatch(approvalUserInit());
      dispatch(searchAllUsersAction());
    }
  }, [approvalResult, dispatch]);

  // 활성/비활성 토글 후 목록 재조회
  useEffect(() => {
    if (useYnResult && useYnResult.retCode === "S00000") {
      dispatch(updateUseYnInit());
      dispatch(searchAllUsersAction());
    }
  }, [useYnResult, dispatch]);

  // 삭제 후 목록 재조회
  useEffect(() => {
    if (deleteResult && deleteResult.retCode === "S00000") {
      dispatch(deleteUserInit());
      dispatch(searchAllUsersAction());
    }
  }, [deleteResult, dispatch]);

  const onApprove = useCallback(
    mbrId => dispatch(approvalUserAction({ mbrId, status: "APPROVAL" })),
    [dispatch]
  );
  const onReject = useCallback(
    mbrId => dispatch(approvalUserAction({ mbrId, status: "REJECT" })),
    [dispatch]
  );
  const onToggleUseYn = useCallback(
    (mbrId, useYn) => dispatch(updateUseYnAction({ mbrId, useYn })),
    [dispatch]
  );
  const onDelete = useCallback(
    (mbrId, mbrName) => {
      if (window.confirm(`'${mbrName || mbrId}' 회원을 삭제하시겠습니까?\n(목록에서 숨겨지며 같은 ID 로 재가입할 수 있습니다.)`)) {
        dispatch(deleteUserAction({ mbrId }));
      }
    },
    [dispatch]
  );

  const { joinRequests, members } = useMemo(() => {
    const list = userList || [];
    return {
      joinRequests: list.filter(u => u.status === "REQUEST"),
      members: list.filter(u => u.status !== "REQUEST")
    };
  }, [userList]);

  const errorMessage =
    (approvalError && (approvalError.retMsg || approvalError.userMsg)) ||
    (useYnError && (useYnError.retMsg || useYnError.userMsg)) ||
    (deleteError && (deleteError.retMsg || deleteError.userMsg)) ||
    null;

  return (
    <UserManagement
      joinRequests={joinRequests}
      members={members}
      onApprove={onApprove}
      onReject={onReject}
      onToggleUseYn={onToggleUseYn}
      onDelete={onDelete}
      isLoading={isLoading}
      isApprovalLoading={isApprovalLoading || isLoading}
      isUseYnLoading={isUseYnLoading || isLoading}
      isDeleteLoading={isDeleteLoading || isLoading}
      errorMessage={errorMessage}
    />
  );
};

export default UserManagementContainer;
